/*
 This file is auto-generated, do not edit
*/

'use strict';
exports.ApiClient = require("./api-client").ApiClient;
exports.ApiError = require("./errors/api-error").ApiError;
exports.ResponseError = require("./errors/response-error").ResponseError;
exports.TimeoutError = require("./errors/timeout-error").TimeoutError;
exports.MergeUsers = require("./requests/merge-users").MergeUsers;
exports.AddDetailView = require("./requests/add-detail-view").AddDetailView;
exports.AddPurchase = require("./requests/add-purchase").AddPurchase;
exports.AddRating = require("./requests/add-rating").AddRating;
exports.AddCartAddition = require("./requests/add-cart-addition").AddCartAddition;
exports.AddBookmark = require("./requests/add-bookmark").AddBookmark;
exports.SetViewPortion = require("./requests/set-view-portion").SetViewPortion;
exports.RecommendItemsToUser = require("./requests/recommend-items-to-user").RecommendItemsToUser;
exports.RecommendItemsToItem = require("./requests/recommend-items-to-item").RecommendItemsToItem;
exports.RecommendNextItems = require("./requests/recommend-next-items").RecommendNextItems;
exports.RecommendItemSegmentsToUser = require("./requests/recommend-item-segments-to-user").RecommendItemSegmentsToUser;
exports.RecommendItemSegmentsToItem = require("./requests/recommend-item-segments-to-item").RecommendItemSegmentsToItem;
exports.RecommendItemSegmentsToItemSegment = require("./requests/recommend-item-segments-to-item-segment").RecommendItemSegmentsToItemSegment;
exports.SearchItems = require("./requests/search-items").SearchItems;
exports.SearchItemSegments = require("./requests/search-item-segments").SearchItemSegments;
exports.Batch = require("./requests/batch").Batch;
